import UIDemo from './container/index';

export default UIDemo;



// WEBPACK FOOTER //
// ./src/views/ui-demo/index.js